import { z } from 'zod';

export const reportsRequestSchema = z.object({
  status: z.enum(['Passive', 'Active', 'Deleted']).optional(),
});

export const reportsResponseSchema = z.any();

export type ReportsRequest = z.infer<typeof reportsRequestSchema>;
export type ReportsResponse = z.infer<typeof reportsResponseSchema>;

export const campaignReportStatusValueSchema = z.enum(['NotFound', 'Scheduled', 'Enqueued', 'Processing']).nullable().catch(null);

export const campaignReportLastRequestSchema = z
  .object({
    jobId: z.string().nullable(),
    startDate: z.string(),
    endDate: z.string(),
    requestedDate: z.string(),
    requestedByOrganizationUserId: z.string(),
  })
  .nullable();

export const campaignReportStatusSchema = z.object({
  status: campaignReportStatusValueSchema,
  isRunning: z.boolean(),
  jobId: z.string().nullable(),
  lastRequest: campaignReportLastRequestSchema,
});

export const startCampaignReportRequestSchema = z.object({
  startDate: z.string(),
  endDate: z.string(),
});

export type CampaignReportStatus = z.infer<typeof campaignReportStatusValueSchema>;
export type CampaignReportStatusResponse = z.infer<typeof campaignReportStatusSchema>;
export type StartCampaignReportRequest = z.infer<typeof startCampaignReportRequestSchema>;
